module.exports = __webpack_public_path__ + "img/yszc-gszc-gszc.57efc952.png";